import Cookies from 'universal-cookie';
export const SystemConstants = {
  INITIAL_POSITION: 0,
};

export const taskIdPattern = /^WT[0-9a-fA-F]{32}$/;

export const removeCookies = (key: string) => {
  const cookies = new Cookies();
  if (cookies.get(`task_sid${key}`)) {
    cookies.remove(`task_sid${key}`);
  }
};
export const LANGUAGE_ES = 'es';